"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzRadio = void 0;
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.VbzRadio = (_a) => {
    var { children, id, name, className, label = 'Smiles', disabled = false, dark = false, isError = false, errorMessage, checked, value, onChange, labelStyle = 'caption' } = _a, params = __rest(_a, ["children", "id", "name", "className", "label", "disabled", "dark", "isError", "errorMessage", "checked", "value", "onChange", "labelStyle"]);
    let breakLabels = label;
    if (label.length >= 30 && !label.includes(' ')) {
        breakLabels = `${label.slice(0, 25)} ${label.slice(25)}`;
    }
    const renderLabel = () => (react_1.default.createElement("span", { className: `vbz-radio-label-${labelStyle}` }, breakLabels));
    return (react_1.default.createElement(reactstrap_1.CustomInput, Object.assign({ id: id, type: "radio", name: name, disabled: disabled, className: className_1.mapToCssModules([
            !className ? '' : className,
            !dark ? '' : 'dark',
            !isError ? '' : 'error',
            !errorMessage ? 'without-error' : '',
        ]), label: renderLabel(), checked: checked, value: value, onChange: onChange }, params),
        react_1.default.createElement("div", { className: `vbz-radio-out ${dark && 'dark'}` }),
        errorMessage ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: "vbz-radio-error" }, errorMessage))) : null,
        children));
};
//# sourceMappingURL=index.js.map